import React from "react";
import { NavLink } from "react-router-dom";

function Footer(prop) {
  let items = [
    { to: "/faqs", title: "FAQs" },
    { to: "/userAgreement", title: "User Agreement" },
    { to: "/privacyPolicy", title: "Privacy Policy" },
    { to: "/learnMore", title: "Learn More" },
  ];
  return (
    <div className="flex   gap-12 bg-footer_bg w-full">
      <ul className="pl-20 flex items-center w-full gap-12 mt-4 ">
        {items.map((item) => {
          return (
            <li>
              <NavLink target='_blank' rel="noopener noreferrer" className="text-footer_text" to={item.to}>
                {item.title}
              </NavLink>
            </li>
          );
        })}
      </ul>
      <div className="flex justify-end mt-4 pr-24 w-full">
        <p className=" text-footer_text">Copyright</p>
        <img
          className=" mt-2 h-2.5 w-2.5 mx-1"
          src={require("../images/icons/copyright_icon.png")}
        />
        <p className=" text-footer_text">2022 Ignite</p>
      </div>
    </div>
  );
}
export default Footer;